
export type IStopListState = {
    name: string;
    id: number;
    stop_name:string;
    stop_code: string;
    location: string;
    created_by: string;
}

export enum IStopListActionTypes {
    FETCH_STOPS_LIST_REQUEST = 'FETCH_STOPS_LIST_REQUEST',
    FETCH_STOPS_LIST_SUCCESS = 'FETCH_STOPS_LIST_SUCCESS',
    FETCH_STOPS_LIST_FAILURE = 'FETCH_STOPS_LIST_FAILURE',

}

export type IStopListActionCreator = {
    type: string;
    payload: IStopListState;
  };
